import * as React from 'react';

function AlertSVG(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={45}
      height={45}
      fill="none"
      viewBox="0 0 24 24"
      {...props}
    >
      <g clipPath="url(#a)">
        <path
          fill="#d63384"
          fillRule="evenodd"
          d="M9.827 2.229c.967-1.639 3.38-1.639 4.347 0l9.486 16.073c.998 1.691-.296 3.698-2.174 3.698H2.514C.636 22-.658 19.993.34 18.302L9.827 2.23Zm.232 4.826A1 1 0 0 1 11.057 6h1.886a1 1 0 0 1 .998 1.055l-.389 7a1 1 0 0 1-.998.945h-1.108a1 1 0 0 1-.998-.944l-.39-7ZM14 18a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z"
          clipRule="evenodd"
        />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#d63384" d="M0 0h24v24H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}
export default AlertSVG;
